<template>
  <div class="activity">
    <!-- <div class="snow"></div> -->
    <!-- pc -->
    <div v-if="!isCollapse" class="pc-activity">
      <!-- <div class="activity-exchange">
        <div class="change-title">
          <img src="../../assets/images/activity/img_txt_activity01.png" />
        </div>
        <div class="change-wrap">
          <div class="wrap-title" v-if="showPoint">
            <p>เกล็ดหิมะที่มี：<img src="../../assets/images/activity/icn_snowflake_activity01.png" /><span>{{point}}</span></p>
            <p @click="goCenter()" style="cursor: pointer;z-index:999">รางวัลของฉัน</p>
          </div>
          <div class="wrap-cont">
            <p>
              <label for="a" v-if="point10 == false">
								<input class="conta" type="radio" name="rrr" value="10">
								<span></span>
                <div style="position: absolute;width: 80%;color:#68748e;text-align:center;font-size:5%;bottom:37%;">คงเหลือ {{ pointRemain10?pointRemain10:0}}</div>
								<span @click="getData($event,'10')" class="btn">
									<img src="../../assets/images/activity/but_receive_card.png" />
								</span>
							</label>
              <label for="a" v-else-if="point10 == true">
								<input class="conta" type="radio" name="rrr" value="10">
								<span></span>
                <div style="position: absolute;width: 80%;color:#68748e;text-align:center;font-size:5%;bottom:37%;">คงเหลือ {{ pointRemain10?pointRemain10:0}}</div>
								<span class="btn">
									<img src="../../assets/images/activity/but_receive_card02.png" />
								</span>
							</label>
							<label for="a" v-else>
								<input class="conta" type="radio" name="rrr" value="">
								<span :style="{ 'background': 'url(' + require('../../assets/images/activity/img_card_money01_ash.png') + ') no-repeat', 'background-size': '100%'}"></span>
                <span class="btn">
									<img src="../../assets/images/activity/but_receive_card03.png" />
								</span>
              </label>

              <label for="b" v-if="point50 == false">
								<input class="contb" type="radio" name="rrr" value="50">
									<span></span>
                <div style="position: absolute;width: 80%;color:#68748e;text-align:center;font-size:5%;bottom:37%;">คงเหลือ {{ pointRemain50?pointRemain50:0}}</div>
									<span @click="getData($event,'50')" class="btn">
										<img src="../../assets/images/activity/but_receive_card.png" />
									</span>
								</label>
                 <label for="b" v-else-if="point50 == true">
								<input class="contb" type="radio" name="rrr" value="50">
									<span></span>
                <div style="position: absolute;width: 80%;color:#68748e;text-align:center;font-size:5%;bottom:37%;">คงเหลือ {{ pointRemain50?pointRemain50:0}}</div>
									<span class="btn">
										<img src="../../assets/images/activity/but_receive_card02.png" />
									</span>
								</label>
								<label for="b" v-else>
								<input class="contb" type="radio" name="rrr" value="">
									<span :style="{ 'background': 'url(' + require('../../assets/images/activity/img_card_money01-1_ash.png') + ') no-repeat', 'background-size': '100%'}"></span>
                  <span class="btn">
                    <img src="../../assets/images/activity/but_receive_card03.png" />
                  </span>
                </label>

              <label for="c" v-if="point100 == false">
								<input class="contc" type="radio" name="rrr" value="100">
									<span></span>
                <div style="position: absolute;width: 80%;color:#68748e;text-align:center;font-size:5%;bottom:37%;">คงเหลือ {{ pointRemain100?pointRemain100:0}}</div>
									<span @click="getData($event,'100')" class="btn">
										<img src="../../assets/images/activity/but_receive_card.png" />
									</span>
							</label>
              <label for="c" v-else-if="point100 == true">
								<input class="contc" type="radio" name="rrr" value="100">
									<span></span>
                <div style="position: absolute;width: 80%;color:#68748e;text-align:center;font-size:5%;bottom:37%;">คงเหลือ {{ pointRemain100?pointRemain100:0}}</div>
									<span class="btn">
										<img src="../../assets/images/activity/but_receive_card02.png" />
									</span>
							</label>
							<label for="c" v-else>
								<input class="contb" type="radio" name="rrr" value="">
									<span :style="{ 'background': 'url(' + require('../../assets/images/activity/img_card_money01-2_ash.png') + ') no-repeat', 'background-size': '100%'}"></span>
                  <span class="btn">
                    <img src="../../assets/images/activity/but_receive_card03.png" />
                  </span>
                </label>
            </p>
          </div>
        </div>
        <div class="change-rule">
          <p class="rule-title">หมายเหตุ</p>
          <p>1.ทุกๆการเติมเงินครบ 100 point รับเกล็ดหิมะ 1 ชิ้น</p>
          <p>2-1.ไม่ว่าจะเป็นการเติมสะสมหรือเติมครั้งแรก หากเติมครบ 1000 point <br>ผู้เล่นมีเกล็ดหิมะครบ 10 ชิ้น
            ถึงจะแลกรหัส PIN 100 บาทได้</p>
          <p>2-2.ผู้เล่นสามารถรับเกล็ดหิมะได้ในช่วงเวลากิจกรรม แต่จะหายไปหลังวันที่ 27</p>
          <p>2-3.ผู้เล่นสามารถสะสมเกล็ดหิมะได้ แต่จะหายไปหลังวันที่ 27 ธ.ค.</p>
          <p>3.เมื่อถึงเวลาจะส่งรหัส PIN ระบบจะเชื่อมกับรหัส PIN<br>
            ผู้เล่นแค่กดปุ่ม"แลกเปลี่ยน"ระบบจะแลกเปลี่ยนรหัสPINอัตโนมัติ</p>
          <p>4.รหัส PIN จะส่งไปที่"รางวัล"ของฉัน</p>
          <p>5.ผู้เล่นสามารถแลกเปลี่ยนได้ 1 ครั้ง ต่อ 1 วัน</p>
        </div>
      </div> -->
      <div class="activity-list">
        <div class="list-title">
          <img src="../../assets/images/activity/img_txt_activity02.png" />
        </div>
        <div style="margin:20px 0" v-if="startTime">
          <img style="width:40vw;" src="../../assets/images/activity/bg_frame_activity03.png" alt="" srcset="">
        </div>
        <div v-else class="list-wrap">
          <ul>
            <li v-for="item in rankList.slice(0, 10)" :key="item.rank">
              <div style="padding-left:0;padding-right:10px;margin-bottom:0 ;" v-if="item.rank == 1"><img src="../../assets/images/activity/icon_01_rank.png" /></div>
              <div style="padding-left:0;padding-right:10px;margin-bottom:0;" v-else-if="item.rank == 2"><img src="../../assets/images/activity/icon_02_rank.png" /></div>
              <div style="padding-left:0;padding-right:10px;margin-bottom:0;" v-else-if="item.rank == 3"><img src="../../assets/images/activity/icon_03_rank.png" /></div>
              <div style="padding-left:10px;margin-bottom:10px ;" v-else>{{item.rank}}</div>
              <div>{{item.username}}</div>
              <div>ยอดแลกตำลึง:&nbsp;{{item.amount}}</div>
            </li>
            <li style="border-top:1px solid #ccc;padding-top: 10px;">
              <div style="padding-left:10px;margin-bottom:10px ;">{{userrank1}}</div>
              <div>{{userrank2}}</div>
              <div>ยอดแลกตำลึง:&nbsp;{{userrank3}}</div>
            </li>
          </ul>
        </div>
        <div class="list-rule">
          <p class="rule-title">หมายเหตุ</p>
          <p>เงื่อนไขกิจกรรม：คำนวนยอดการแลกตำลึงสะสมรวมตลอดระยะเวลากิจกรรมที่หน้ากิจก</p>
          <p>รรม ต้องมียอดแลกตำลึงขั้นต่ำ 3000 </p>
          <p>ตำลึงขึ้นไปถึงจะถื่อว่าเข้าร่วมกิจกรรม วันที่ 4-5 ม.ค.</p>
          <p>จะคำนวนนวนยอดการแลกตำลึง ยืนยันไอดีผู้โชคดี</p>
          <p>และแจกรางวัลในวันที่ 6 ม.ค. เป็นรหัส PIN</p>
          <p>รางวัลกิจกรรม ：</p>
          <p>ผู้ที่แลกตำลึง สูงสุด 10 อันดับแรก ในช่วงกิจกรรม</p>
          <p>ในช่วงกิจกรรม</p>
          <p>อันดับที่ 1 ：รับรหัส Razer Gold PIN มูลค่า 19,000 THB</p>
          <p>อันดับที่ 2：รับรหัส Razer Gold PIN มูลค่า 16,800 THB </p>
          <p>อันดับที่ 3：รับรหัส Razer Gold PIN มูลค่า 14,600 THB </p>
          <p>อันดับที่ 4 ：รับรหัส Razer Gold PIN มูลค่า 12,400 THB </p>
          <p>อันดับที่ 5：รับรหัส Razer Gold PIN มูลค่า 10,200 THB</p>
          <p>อันดับที่ 6：รับรหัส Razer Gold PIN มูลค่า 8,000 THB</p>
          <p>อันดับที่ 7：รับรหัส Razer Gold PIN มูลค่า 6,000 THB</p>
          <p>อันดับที่ 8：รับรหัส Razer Gold PIN มูลค่า 4,000 THB </p>
          <p>อันดับที่ 9：รับรหัส Razer Gold PIN มูลค่า 2,000 THB </p>
          <p>อันดับที่ 10：รับรหัส Razer Gold PIN มูลค่า 500 THB</p>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div v-if="isCollapse" class="mb-activity">
      <!-- <div class="mb-exchange">
        <div class="change-title">
          <img style="width: 80%;" src="../../assets/images/activity/img_mobile_txt_activity01.png" />
        </div>
        <div class="change-wrap">
          <div class="wrap-title" v-if="showPoint">
            <p>เกล็ดหิมะที่มี：<img src="../../assets/images/activity/icn_snowflake_activity01.png" /><span>{{point}}</span></p>
            <p @click="goCenter()" style="z-index:999;">รางวัลของฉัน</p>
          </div>
          <div class="wrap-cont">
            <p>
              <label for="a" v-if="point10 == false">
								<input class="conta" type="radio" name="rrr" value="10">
								<span></span>
                <div style="position: absolute;width: 90%;color:#68748e;text-align:center;font-size: 3vw;bottom: 32%;">คงเหลือ {{ pointRemain10?pointRemain10:0}}</div>
								<span @click="getData($event,'10')" class="btn">
									<img src="../../assets/images/activity/but_receive_card.png" />
								</span>
							</label>
              <label for="a" v-else-if="point10 == true">
								<input class="conta" type="radio" name="rrr" value="10">
								<span></span>
                <div style="position: absolute;width: 90%;color:#68748e;text-align:center;font-size: 3vw;bottom: 32%;">คงเหลือ {{ pointRemain10?pointRemain10:0}}</div>
								<span class="btn">
									<img src="../../assets/images/activity/but_receive_card02.png" />
								</span>
							</label>
							<label for="a" v-else>
								<input class="conta" type="radio" name="rrr" value="">
								<span :style="{ 'background': 'url(' + require('../../assets/images/activity/img_card_money01_ash.png') + ') no-repeat', 'background-size': '100%'}"></span>
                <span class="btn">
									<img src="../../assets/images/activity/but_receive_card03.png" />
								</span>
              </label>

              <label for="b" v-if="point50 == false">
								<input class="contb" type="radio" name="rrr" value="50">
									<span></span>
                <div style="position: absolute;width: 90%;color:#68748e;text-align:center;font-size: 3vw;bottom: 32%;">คงเหลือ {{ pointRemain50?pointRemain50:0}}</div>
									<span @click="getData($event,'50')" class="btn">
										<img src="../../assets/images/activity/but_receive_card.png" />
									</span>
								</label>
                <label for="b" v-else-if="point50 == true">
								<input class="contb" type="radio" name="rrr" value="50">
									<span></span>
                <div style="position: absolute;width: 90%;color:#68748e;text-align:center;font-size: 3vw;bottom: 32%;">คงเหลือ {{ pointRemain50?pointRemain50:0}}</div>
									<span class="btn">
										<img src="../../assets/images/activity/but_receive_card02.png" />
									</span>
								</label>
								<label for="b" v-else>
								<input class="contb" type="radio" name="rrr" value="">
									<span :style="{ 'background': 'url(' + require('../../assets/images/activity/img_card_money01-1_ash.png') + ') no-repeat', 'background-size': '100%'}"></span>
                  <span class="btn">
                    <img src="../../assets/images/activity/but_receive_card03.png" />
                  </span>
                </label>

              <label for="c" v-if="point100 == false">
								<input class="contc" type="radio" name="rrr" value="100">
									<span></span>
                <div style="position: absolute;width: 90%;color:#68748e;text-align:center;font-size: 3vw;bottom: 32%;">คงเหลือ {{ pointRemain100?pointRemain100:0}}</div>
									<span @click="getData($event,'100')" class="btn">
										<img src="../../assets/images/activity/but_receive_card.png" />
									</span>
							</label>
              <label for="c" v-else-if="point100 == true">
								<input class="contc" type="radio" name="rrr" value="100">
									<span></span>
                <div style="position: absolute;width: 90%;color:#68748e;text-align:center;font-size: 3vw;bottom: 32%;">คงเหลือ {{ pointRemain100?pointRemain100:0}}</div>
									<span class="btn">
										<img src="../../assets/images/activity/but_receive_card02.png" />
									</span>
							</label>
							<label for="c" v-else>
								<input class="contb" type="radio" name="rrr" value="">
									<span :style="{ 'background': 'url(' + require('../../assets/images/activity/img_card_money01-2_ash.png') + ') no-repeat', 'background-size': '100%'}"></span>
                  <span class="btn">
                    <img src="../../assets/images/activity/but_receive_card03.png" />
                  </span>
                </label>
            </p>
          </div>
        </div>
        <div style="padding-bottom: 20px;" class="change-rule">
          <p class="rule-title">หมายเหตุ</p>
          <p>1.ทุกๆการเติมเงินครบ 100 point รับเกล็ดหิมะ 1 ชิ้น</p>
          <p>2-1.ไม่ว่าจะเป็นการเติมสะสมหรือเติมครั้งแรก หากเติมครบ 1000 point <br>ผู้เล่นมีเกล็ดหิมะครบ 10 ชิ้น
            ถึงจะแลกรหัส PIN 100 บาทได้</p>
          <p>2-2.ผู้เล่นสามารถรับเกล็ดหิมะได้ในช่วงเวลากิจกรรม แต่จะหายไปหลังวันที่ 27</p>
          <p>2-3.ผู้เล่นสามารถสะสมเกล็ดหิมะได้ แต่จะหายไปหลังวันที่ 27 ธ.ค.</p>
          <p>3.เมื่อถึงเวลาจะส่งรหัส PIN ระบบจะเชื่อมกับรหัส PIN<br>
            ผู้เล่นแค่กดปุ่ม"แลกเปลี่ยน"ระบบจะแลกเปลี่ยนรหัสPINอัตโนมัติ</p>
          <p>4.รหัส PIN จะส่งไปที่"รางวัล"ของฉัน</p>
          <p>5.ผู้เล่นสามารถแลกเปลี่ยนได้ 1 ครั้ง ต่อ 1 วัน</p>
        </div>
      </div> -->
      <div class="mb-exchange">
        <div class="change-title">
          <img style="width: 80%;" src="../../assets/images/activity/img_mobile_txt_activity02.png" />
        </div>
        <div style="margin:0 20px" v-if="startTime">
          <img style="width:100%;" src="../../assets/images/activity/bg_frame_activity03.png" alt="" srcset="">
        </div>
        <div style="width: 90%;" v-else class="list-wrap">
          <ul>
            <li v-for="item in rankList.slice(0, 10)" :key="item.rank">
              <div style="padding-left:0;padding-right:10px;margin-bottom:0 ;" v-if="item.rank == 1"><img src="../../assets/images/activity/icon_01_rank.png" /></div>
              <div style="padding-left:0;padding-right:10px;margin-bottom:0;" v-else-if="item.rank == 2"><img src="../../assets/images/activity/icon_02_rank.png" /></div>
              <div style="padding-left:0;padding-right:10px;margin-bottom:0;" v-else-if="item.rank == 3"><img src="../../assets/images/activity/icon_03_rank.png" /></div>
              <div style="padding-left:10px;margin-bottom:10px ;" v-else>{{item.rank}}</div>
              <div>{{item.username}}</div>
              <div>{{item.amount}}</div>
            </li>
            <li style="border-top:1px solid #ccc;padding-top: 10px;">
              <div style="padding-left:10px;margin-bottom:10px ;">{{userrank1}}</div>
              <div>{{userrank2}}</div>
              <div>{{userrank3}}</div>
            </li>
          </ul>
        </div>
        <div style="width: 90%;padding-bottom: 30px;" class="list-rule">
          <p class="rule-title">หมายเหตุ</p>
          <p>เงื่อนไขกิจกรรม：คำนวนยอดการแลกตำลึงสะสมรวมตลอดระยะเวลากิจกรรมที่หน้ากิจก</p>
          <p>รรม ต้องมียอดแลกตำลึงขั้นต่ำ 3000 </p>
          <p>ตำลึงขึ้นไปถึงจะถื่อว่าเข้าร่วมกิจกรรม วันที่ 4-5 ม.ค.</p>
          <p>จะคำนวนนวนยอดการแลกตำลึง ยืนยันไอดีผู้โชคดี</p>
          <p>และแจกรางวัลในวันที่ 6 ม.ค. เป็นรหัส PIN</p>
          <p>รางวัลกิจกรรม ：</p>
          <p>ผู้ที่แลกตำลึง สูงสุด 10 อันดับแรก ในช่วงกิจกรรม</p>
          <p>ในช่วงกิจกรรม</p>
          <p>อันดับที่ 1 ：รับรหัส Razer Gold PIN มูลค่า 19,000 THB</p>
          <p>อันดับที่ 2：รับรหัส Razer Gold PIN มูลค่า 16,800 THB </p>
          <p>อันดับที่ 3：รับรหัส Razer Gold PIN มูลค่า 14,600 THB </p>
          <p>อันดับที่ 4 ：รับรหัส Razer Gold PIN มูลค่า 12,400 THB </p>
          <p>อันดับที่ 5：รับรหัส Razer Gold PIN มูลค่า 10,200 THB</p>
          <p>อันดับที่ 6：รับรหัส Razer Gold PIN มูลค่า 8,000 THB</p>
          <p>อันดับที่ 7：รับรหัส Razer Gold PIN มูลค่า 6,000 THB</p>
          <p>อันดับที่ 8：รับรหัส Razer Gold PIN มูลค่า 4,000 THB </p>
          <p>อันดับที่ 9：รับรหัส Razer Gold PIN มูลค่า 2,000 THB </p>
          <p>อันดับที่ 10：รับรหัส Razer Gold PIN มูลค่า 500 THB</p>
        </div>
      </div>
    </div>

		<pang-dialog
      v-if="sureShow"
      :cancelText="$router.lang.get('取消')"
      :submitText="$router.lang.get('確認')"
      @cancel="hintCancel"
      @submit="hintSure"
    >
		<div>การแลกเปลี่ยนครั้งนี้ใช้เกล็ดหิมะ（{{xhnum}}）ชิ้น แลกรางวัลได้วันละ 1 ครั้ง ยืนยันการแลกหรือไม่?</div>
    </pang-dialog>

  </div>
</template>

<script>
  import {useScreenState  } from '../../store';
  import request from '../../api/request'
	import message from '../../utils/message';
	import {
  PangDialog,
} from "../../components";
  export default {
    name: 'Activity',
    data() {
      return {
        screenState: useScreenState(),
				showPoint:false,
				point:'',
				point10:'',
				point50:'',
				point100:'',
        pointRemain10: 0,
        pointRemain50: 0,
        pointRemain100: 0,
				sureShow:false,
        xhnum:"",
        rankList:[],
        userrank1:'',
        userrank2:'',
        userrank3:'',
        startTime:false
      };
		},
		components: {
			PangDialog,
		},
    mounted() {
      this.getPoint();
      this.getList();
    },
    methods: {
	getData(e,num) {
        if (this.screenState.user) {
            if (this.point >= num) {
                this.xhnum = num
                this.sureShow = true;
            }
            else {
                message.showMessage(this, 'เกล็ดหิมะไม่พอ')
            }
        }
        else {
            this.$router.push({ path: '/account/login', query: {returnurl: this.$route.fullPath}})
        }
	},
	hintCancel() {
      this.sureShow = false;
	},
	hintSure(){
		let _this = this
		let data = {
				exchange_point: _this.xhnum,
				promo: 1,
		}
		request.post('/promocodes/retrieve' , data, _this).then(function (res) {
				if (res.status == 200) {
						message.showMessageSuccess(_this, 'แลกเปลี่ยนสำเร็จ')
            _this.sureShow = false;
            // 刷新
            _this.$router.go(0);
				}
				else {
            message.resMessage(res, _this)
            _this.sureShow = false;
				}
		})
	},
      getPoint() {
        let _this = this
        request.get('/promos/1', {}, this).then(function(res) {
          if (res.status == 200) {
						if(res.data.remain_point != undefined){
							_this.showPoint = true
							_this.point = res.data.remain_point
						}
						const remainsArr = res.data.remains;
						const remainsObj = remainsArr.reduce(function(res, x) {
								res[x.exchange_point] = x.exchanged;
								return res;
						}, {})
						let remainsCount = remainsArr.reduce(function(res, x) {
								res[x.exchange_point] = x.count - (x.exchanged?1:0);
								return res;
						}, {})
						_this.point10 = remainsObj[10]
						_this.point50 = remainsObj[50]
						_this.point100 = remainsObj[100]
						_this.pointRemain10 = remainsCount[10]
						_this.pointRemain50 = remainsCount[50]
						_this.pointRemain100 = remainsCount[100]

          } else if (res.status == 404) {
            _this.$router.replace('/404')
          } else {
            message.resMessage(res, _this)
          }
        })
      },
      getList(){
        let _this = this
        request.get('/promos/2', {}, this).then(function(res) {
          if (res.status == 200) {
            _this.rankList = res.data.rankings
            let da = res.data.rankings
            let ddd = da.filter(function(obj){
              return obj.is_me == true
            })
            _this.userrank1 = ddd[0].rank
            _this.userrank2 = ddd[0].username
            _this.userrank3 = ddd[0].amount

            let times = new Date()
            let startTime = new Date(res.data.start_at)
            if(startTime > times){
              // 显示占位
              _this.startTime = true
            }
          } else if (res.status == 404) {
            _this.$router.replace('/404')
          } else {
            message.resMessage(res, _this)
          }
        })
      },
      goCenter(){
        let _this = this
        _this.$router.push('/account?tab=3')
      }
    },
    computed: {
      isCollapse() {
        return this.screenState.screenWidth < 900;
      },
    },
  }
</script>

<style scoped>
  .snow{
    position: fixed;
    left: 0;
    top: 70px;
    width: 100%;
    height: 100%;
    background: url('../../assets/images/activity/xh1.png'),url('../../assets/images/activity/xh2.png');
    animation: 10s snow linear infinite;
    
  }
  .snow img {
    display: block;
    width: 100%;
  }
  @keyframes snow{
    0% {
      background-position: 0 0, 0 0;
    }
    100% {
      background-position: 500px 500px, 1000px 500px;
    }
  }
  .activity {
    
  }
	.pang-dialog >>> .body{
		min-height:60px;
	}
    
	.pang-dialog > div{
		font-size: 16px;
	}
  .activity .activity-exchange {
    text-align: center;
    background: url(../../assets/images/activity/img_bg_activity01.jpg) no-repeat;
    background-size: cover;
    height: calc( 1383 / 1920 * 100vw );
    min-height: 2200px;
  }

  .activity .activity-exchange .change-title img {
    margin-top: 5vw;
  }

  .activity .activity-exchange .change-wrap {
    margin: 2vw;
    width: 40%;
    margin: 0 auto;
  }

  .activity .activity-exchange .change-wrap .wrap-title {
    display: flex;
    font-size: 30px;
  }

  .activity .activity-exchange .change-wrap .wrap-title p {
    flex-grow: 1;
		
  }

  .activity .activity-exchange .change-wrap .wrap-title p:nth-child(1) {
    text-align: left;
    color: #301B1B;
  }

  .activity .activity-exchange .change-wrap .wrap-title p:nth-child(2) {
    text-align: right;
    color: #C6A86C;
  }

  .activity .activity-exchange .change-wrap .wrap-title img {
    vertical-align: middle;
    width: 30px;
    margin: 0 5px;
  }

  .wrap-cont p {
    display: flex;
  }

  .activity .activity-exchange .change-wrap .wrap-cont p label {
    flex-grow: 1;
    position: relative;
    text-align: left;
  }
	.activity .activity-exchange .change-wrap .wrap-cont p label .btn{
		position: absolute;
		bottom: 1vw;
		z-index: 998;
		left: 40%;
    transform: translate(-50%, -50%); 
    text-align: center;
		cursor: pointer;
	}
	.activity .activity-exchange .change-wrap .wrap-cont p label .btn img{
		width: 8vw;
	}
  .activity .activity-exchange .change-rule {
    text-align: left;
    width: 40%;
    margin: 0 auto;
    color: #68748E;
    font-size: 18px;
  }

  .activity .activity-exchange .change-rule p {
    margin-bottom: 0;
  }

  .activity .activity-exchange .change-rule .rule-title {
    color: #301B1B;
    font-size: 30px;
  }

  /* 单选按钮 */
  /* 先将按钮原来的样式隐藏 */
  .conta[type=radio] {
    opacity: 0;
    display: inline-block;
    position: absolute;
    width: 80%;
    height: 15vw;
    /* cursor: pointer; */
  }

  /* 设置紧跟其后的<span>元素的样式，设置背景图片 */
  .conta[type=radio]+span {
    display: inline-block;
    width: 80%;
    height: 15vw;
    background: url('../../assets/images/activity/img_card_money01.png') no-repeat 0px 4px;
    background-size: 100%;
  }

  /* 当按钮被选中时，将<span>换一张背景图片即可 */
  /* .conta[type=radio]:checked+span {
    background: url('../../assets/images/activity/img_card_money01_ash.png') no-repeat 0px 4px;
    background-size: 100%;
  } */

  .contb[type=radio] {
    opacity: 0;
    display: inline-block;
    position: absolute;
    width: 80%;
    height: 15vw;
  }

  /* 设置紧跟其后的<span>元素的样式，设置背景图片 */
  .contb[type=radio]+span {
    display: inline-block;
    width: 80%;
    height: 15vw;
    background: url('../../assets/images/activity/img_card_money01-1.png') no-repeat 0px 4px;
    background-size: 100%;

  }

  /* 当按钮被选中时，将<span>换一张背景图片即可 */
  /* .contb[type=radio]:checked+span {
    background: url('../../assets/images/activity/img_card_money01-1_ash.png') no-repeat 0px 4px;
    background-size: 100%;
  } */

  .contc[type=radio] {
    opacity: 0;
    display: inline-block;
    position: absolute;
    width: 80%;
    height: 15vw;
		
  }

  /* 设置紧跟其后的<span>元素的样式，设置背景图片 */
  .contc[type=radio]+span {
    display: inline-block;
    width: 80%;
    height: 15vw;
    background: url('../../assets/images/activity/img_card_money01-2.png') no-repeat 0px 4px;
    background-size: 100%;

  }

  /* 当按钮被选中时，将<span>换一张背景图片即可 */
  /* .contc[type=radio]:checked+span {
    background: url('../../assets/images/activity/img_card_money01-2_ash.png') no-repeat 0px 4px;
    background-size: 100%;
  } */

  .activity-list {
    text-align: center;
    background: url(../../assets/images/activity/img_bg_activity02.jpg) no-repeat;
    background-size: cover;
    height: calc( 1303 / 1920 * 100vw );
    min-height: 1400px;
  }

  .activity .activity-list .list-title img {
    margin-top: 5vw;
  }

  .list-wrap {
    color: #645B5B;
    width: 40%;
    margin: 0 auto;
  }

  .list-wrap ul {
    background: rgba(255, 255, 255, 0.4);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.11);
    padding: 15px 0;
  }

  .list-wrap ul li {
    display: flex;
    padding: 0 10px;
  }

  .list-wrap ul li img{
    width: 30px;
  }

  .list-wrap ul li div:nth-child(1) {
    width: 20%;
    text-align: left;
  }
  .list-wrap ul li div:nth-child(2) {
    width: 50%;
    text-align: left;
  }
  .list-wrap ul li div:nth-child(3) {
    width: 30%;
    text-align: left;
  }

  .list-rule {
    text-align: left;
    width: 40%;
    margin: 0 auto;
    color: #68748E;
    font-size: 16px;
  }

  .list-rule p {
    margin: 2px 0;
  }

  .list-rule .rule-title {
    color: #301B1B;
    font-size: 30px;
  }

  .mb-exchange {
    text-align: center;
    background: url(../../assets/images/activity/img_mobile_bg_activity01.jpg) no-repeat;
    background-size: 100% 100%;
  }

  .mb-exchange .change-title img {
    margin: 30px 20px;
    width: 100%;
  }

  .mb-exchange .change-wrap {
    margin: 2vw;
    width: 90%;
    margin: 0 auto;
  }

  .mb-exchange .change-wrap .wrap-title {
    display: flex;
    font-size: 15px;
  }

  .mb-exchange .change-wrap .wrap-title p {
    flex-grow: 1;
		
  }

  .mb-exchange .change-wrap .wrap-title p:nth-child(1) {
    text-align: left;
    color: #301B1B;
  }

  .mb-exchange .change-wrap .wrap-title p:nth-child(2) {
    text-align: right;
    color: #C6A86C;
  }

  .mb-exchange .change-wrap .wrap-title img {
    vertical-align: middle;
    width: 20px;
    margin: 0 5px;
  }

  .mb-exchange .change-wrap .wrap-cont {
    overflow-x: auto;
  }

  .mb-exchange .change-wrap .wrap-cont p {
    width: 500px;
  }

  .mb-exchange .change-wrap .wrap-cont p label {
    position: relative;
    text-align: left;
    width: 150px;
  }
	.mb-exchange .change-wrap .wrap-cont p label .btn{
		position: absolute;
		bottom: 0;
		z-index: 999;
		left: 45%;
    transform: translate(-50%, -50%); 
    text-align: center;
		cursor: pointer;
	}
	.mb-exchange .change-wrap .wrap-cont p label .btn img{
		width: 100px;
	}
  .mb-exchange .change-rule {
    text-align: left;
    width: 90%;
    margin: 0 auto;
    color: #68748E;
    font-size: 18px;
  }

  .mb-exchange .change-rule p {
    margin: 0 auto;
  }

  .mb-exchange .change-rule .rule-title {
    color: #301B1B;
    font-size: 30px;
  }

  .mb-exchange .list-rule p {
    margin: 0 auto;
  }

  @media screen and (max-width: 900px) {
    .contc[type=radio] {
      width: 90%;
      height: 180px;
    }

    .conta[type=radio]+span {
      width: 90%;
      height: 180px;
    }

    .contc[type=radio] {
      width: 90%;
      height: 180px;
    }

    .contb[type=radio]+span {
      width: 90%;
      height: 180px;
    }

    .contc[type=radio] {
      width: 90%;
      height: 180px;
    }

    .contc[type=radio]+span {
      width: 90%;
      height: 180px;
    }
  }
</style>
